import PropTypes from 'prop-types'
import React from 'react'

// import LinkInlineArrowShort from 'components/LinkInlineArrowShort'

import DiscountLabel from 'components/DiscountLabel'

import {
  Layout,
  Title,
  LayoutWrapper,
  TitleBlock,
  LayoutBlock,
  Label,
  Subtitle,
  TextMediumStyled,
  TextLHStyled,
  DiscountLabelStyled,
  TextWithCheckStyled,
} from './styles'

/**
 * CartItemLayout
 *
 * @param {object} props - properties of component
 * @returns {node} CartItemLayout
 */
const CartItemLayout = props => {
  const {
    title,
    subtitle,
    afterTitleContent,
    // titleLink,
    descrBlockContent,
    imageContent,
    rightBlockContent,
    className,
    alignByCenter,
    layoutRef,
    isSpecial,
    label,
    discount,
    discountLabel,
    isMobile,
    isEmpty,
  } = props
  // Assembly the title content
  let titleContent = null

  // if (titleLink) {
  //   titleContent = (
  //     <LinkInlineArrowShort size="cart" to={titleLink}>
  //       {title}
  //     </LinkInlineArrowShort>
  //   )
  // } else {

  const subtitleBox = React.useMemo(
    () =>
      subtitle && subtitle.list ? (
        <Subtitle>
          {subtitle.list.map((item, i) => (
            <TextWithCheckStyled
              key={i}
              text={item}
              bg={isEmpty ? 'white' : 'catskillWhite'}
              iconColor="blackOp5"
            />
          ))}
        </Subtitle>
      ) : null,
    [subtitle, isEmpty],
  )

  titleContent = (
    <>
      {(label || discount > 0) && (
        <Label>
          {label && (
            <TextLHStyled dangerouslySetInnerHTML={{ __html: label }} />
          )}
          {discount && (
            <DiscountLabel
              text={discountLabel}
              isWithFilling={true}
              isWithoutShift={true}
              value={discount}
            />
          )}
        </Label>
      )}
      <TextMediumStyled
        isSpecial={isSpecial}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {discount > 0 && (
        <>
          &nbsp;
          <DiscountLabelStyled
            text={discountLabel}
            isWithFilling={true}
            isWithoutShift={true}
            value={discount}
          />
        </>
      )}
      {!isMobile && subtitleBox}
    </>
  )
  // }
  const descrClassNames =
    'col-6 pt-2 order-3 col-md-4 offset-md-1 col-lg-3 pt-lg-0 offset-lg-0'
  const rightClassNames = `col-6 ${
    isSpecial ? 'order-1 order-md-2' : 'order-2'
  } col-md-5 col-lg-3 order-lg-last`

  return (
    <LayoutWrapper ref={layoutRef} className={className}>
      <div className="container-fluid">
        <Layout className="row">
          <div
            className={`position-relative order-1 ${
              isSpecial ? 'col-6' : ''
            } col-md-1 col-lg-2`}
          >
            {imageContent ? imageContent : null}
          </div>

          <TitleBlock
            centered={alignByCenter}
            isEmpty={isEmpty}
            className={`${
              isSpecial ? 'col-12 order-2 order-md-1' : 'col-6 order-1'
            } col-md-4 col-lg-3`}
          >
            <Title>{titleContent}</Title>
          </TitleBlock>

          <div className="position-relative col-12 order-0 col-md-2 order-md-2 col-lg-1">
            {afterTitleContent}
          </div>

          <LayoutBlock className={rightClassNames} centered={alignByCenter}>
            {rightBlockContent}
          </LayoutBlock>

          <LayoutBlock
            className={descrClassNames}
            centered={alignByCenter}
            isWideOnMobile={true}
          >
            {descrBlockContent}
            {!isSpecial && isMobile && subtitleBox}
          </LayoutBlock>
        </Layout>
      </div>
    </LayoutWrapper>
  )
}

CartItemLayout.propTypes = {
  /** Content of description block (in center on lg) */
  descrBlockContent: PropTypes.node,

  /** Content of right block (in right on lg)*/
  rightBlockContent: PropTypes.node.isRequired,

  /** Title of block */
  title: PropTypes.string.isRequired,

  /** Content for after title block */
  afterTitleContent: PropTypes.node,

  /** Vertical align by center flag */
  alignByCenter: PropTypes.bool,

  /** Class name for container */
  className: PropTypes.string,

  /** Object with images */
  imageContent: PropTypes.node,

  /** Link when card of product is empty */
  titleLink: PropTypes.string,

  /** Is special offer */
  isSpecial: PropTypes.bool,

  /** Label above title */
  label: PropTypes.string,

  /** Discount label */
  discountLabel: PropTypes.string,

  /** Show discount in label */
  discount: PropTypes.number,

  /** Subtitle */
  subtitle: PropTypes.object,

  /** Ref to layout */
  layoutRef: PropTypes.object,

  /** Is mobile breakpoint */
  isMobile: PropTypes.bool,

  /** Is empty mode */
  isEmpty: PropTypes.bool,
}

CartItemLayout.defaultProps = {
  alignByCenter: true,
  className: '',
}

export default CartItemLayout
